import { ADD_LEAD_ENDPOINT } from '../../config'

export function buildParamsFromTags({ tags }) {
  const getProps = Object.entries(tags)
  let params = ''

  getProps.forEach(([key, value], i) => {
    const encodeValue = encodeURIComponent(value)
    const paramSymbol = i === 0 ? '?' : '&'
    const joinParams = `${paramSymbol}${key}=${encodeValue}`
    params += joinParams
  })

  return ADD_LEAD_ENDPOINT + params
}
